import { Component, Input, OnInit } from '@angular/core';
import { TYPE_SECTIONS } from 'app/core/models/constans.model';
import { Item, Menu } from 'app/menu/models/menu.model';
import { MenuService } from 'app/menu/services/menu.service';

@Component({
    selector: 'app-separator',
    templateUrl: './separator.component.html',
    styleUrls: ['./separator.component.scss'],
    standalone: false
})
export class SeparatorComponent implements OnInit {
  /**
   * Informacion de la seccion que hara como separador
   *  de productos de una misma seccion
   */
  @Input() separator: Item = {} as Item;
  /**
   * Informacion del menu para sacar info como
   * tipografia, colores, etc
   */
  @Input() menu: Menu = {} as Menu;
  /**
   * Tipos de secciones
   */
  readonly TYPE_SECTIONS = TYPE_SECTIONS;
  /**
   * Selector de idioma
   */
  language = 'ES';
  constructor(
    public menuService: MenuService
  ) { }

  ngOnInit(): void {
    this.menuService.language$.subscribe((lang: string) => {
      this.language = lang;
    });
  }



}
